import { render } from "./HomeAlbum.vue?vue&type=template&id=20993664"
import script from "./HomeAlbum.vue?vue&type=script&lang=js"
export * from "./HomeAlbum.vue?vue&type=script&lang=js"
script.render = render

export default script